module.exports = __webpack_public_path__ + "img/depart.9a0018b0.svg";